<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>publish</md-icon>교우회 일괄 처리
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">데이터 업로드</h5>
              <div class="inline-flex mb10">
                <input type="file" class="hidden-input-file" id="bundleFileInput" accept="text/plain">
                <input type="text" v-model="dataTextFileName" disabled>
                <button v-focus @click="onClickSearchFile">
                  <md-icon>search</md-icon>데이터 파일 찾기
                </button>
              </div>
              <md-button class="md-success md-sm full-size-button" @click="prepareTextUpdate" :disabled="!textFile">
                <md-icon>publish</md-icon>데이터 업로드
              </md-button>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>publish</md-icon>일괄 처리 데이타 선택
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">엑셀 데이터 업로드</h5>
              <div class="inline-flex mb10">
                <input type="file" class="hidden-input-file" id="bundleExcelFileInput" accept=".xlsx">
                <input type="text" v-model="dataExcelFileName" disabled>
                <button v-focus @click="onClickSearchExcelFile">
                  <md-icon>search</md-icon>엑셀 파일 찾기
                </button>
              </div>
              <md-button class="md-success md-sm full-size-button" @click="prepareExcelUpdate" :disabled="!excelFile">
                <md-icon>publish</md-icon>엑셀 파일 업로드
              </md-button>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">
        <!-- 목록 시작 -->
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon><span style="color: #6a1b9a; font-weight: bold;"> {{uploadDataNm}}</span> 업로드 대상 데이타
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            </div>

            <grid ref="executivesGrid"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
            ></grid>


            <!-- <md-table
              :value="queriedData"
              class="paginated-table table-striped table-hover text-align-center h-scroll"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="에러코드">{{ "" }}</md-table-cell>
                <md-table-cell md-label="순번">{{ item.id }}</md-table-cell>
                <md-table-cell md-label="시간">{{ "" }}</md-table-cell>
                <md-table-cell md-label="메시지">{{ "" }}</md-table-cell>
                <md-table-cell md-label="교우번호">{{ item.memberNo }}</md-table-cell>
                <md-table-cell md-label="교우명">{{ item.memberHnm }}</md-table-cell>
                <md-table-cell md-label="한자명">{{ item.memberCnm }}</md-table-cell>
                <md-table-cell md-label="영문명">{{ item.memberEnm }}</md-table-cell>
              </md-table-row>
            </md-table> -->


          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div>&nbsp;</div>
            <div>
              <md-button class="md-info md-sm" @click ="runBundleUpdate" :disabled="this.tableData.length === 0">
                <md-icon>done_all</md-icon>일괄 등록
              </md-button>
            </div>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import Swal from "sweetalert2";
import parser from "@/kuaa/kuaa-parser";
import URL_CONST from "@/kuaa/kuaa-url-const";
import axios from "axios";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaApi from "@/kuaa/kuaa-api";

export default {
  components: {
    grid: Grid,
  },

  created() {
    this.initGrid();
  },

  data(){
    return{
      formatter,
      gridProps: {},
      currentSort: "name",
      currentSortOrder: "asc",
      textFile: null,
      dataTextFileName: null,
      excelFile: null,
      dataExcelFileName: null,
      tableData: [],
      total: 0,
      wrkDiv: null,
      uploadDataNm: null
    };
  },

  methods: {
    onClickSearchFile() {
      let input = document.getElementById("bundleFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.dataTextFileName = file.name;
        this.textFile = file;
      };
      input.click();
    },

    onClickSearchExcelFile() {
      let input = document.getElementById("bundleExcelFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.dataExcelFileName = file.name;
        this.excelFile = file;
      };
      input.click();
    },

    prepareTextUpdate() {
      parser.parseTextNewMemberData(this.textFile, (list) =>{
        // console.log("<<<<", list);
        this.total = list.length;
        this.tableData = list;
        this.wrkDiv = "1";
        this.uploadDataNm = "[교우회]";

        this.$refs.executivesGrid.invoke("clear");
        this.$refs.executivesGrid.invoke("appendRows", list);
      });
    },

    prepareExcelUpdate() {
      parser.parseExcelNewMemberData(this.excelFile, (list) =>{
        // console.log("<<<<", list);
        this.total = list.length;
        this.tableData = list;
        this.wrkDiv = "2";
        this.uploadDataNm = "교우회[외부]";

        this.$refs.executivesGrid.invoke("clear");
        this.$refs.executivesGrid.invoke("appendRows", list);
      });
    },

    // 일괄 등록 서버에 전송
    runBundleUpdate() {
        Swal.fire(kuaaFnc.getSwalModaloptions('confirm', {title: this.uploadDataNm  + " 일괄 등록"}))
            .then(result => {
                if (result.value) {
                  // 데이터 deep copy (가공이 필요해서 사용하고 버립니다.)
                  let clonedData = JSON.parse(JSON.stringify(this.tableData));
                  clonedData.forEach(item => {
                    delete item.id;
                  });

                  kuaaApi.sendServer(
                      this.wrkDiv == "1"? URL_CONST.SAVE_NEW_MULTI_MEMBER: URL_CONST.SAVE_NEW_MULTI_MEMBER2,
                      clonedData,
                      "post",
                      response => {
                        //kuaaFnc.showSwal("임원단 정보 저장", '저장 처리 되었습니다.');

                        if (response.data) {
                          if (response.data.success) {
                            kuaaFnc.showSwal("교우정보(주소) 일괄처리", '일괄 등록 되었습니다.');
                          } else {
                            kuaaFnc.showSwal("교우정보(주소) 일괄처리", response.data.resultMessage);
                          }
                        }
                      }
                  );
                }
            });
    },

    initGrid(listData) {
      this.gridProps = kuaaFnc.setGridInit(null, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['columns'] = [
        {header: '교우번호', name: 'memberNo', align: "center", width: "120", sortable: true},
        {header: '교우명', name: 'memberHnm', align: "center", width: "120", sortable: true},
        {header: '성별', name: 'sex', align: "center", width: "120", sortable: true},
        {header: '주민번호', name: 'registerNo', align: "center", width: "120", sortable: true},
        {header: '교우직위코드', name: 'memberorgGb', align: "center", width: "120", sortable: true},
        {header: '대학코드', name: 'collegeCd', align: "center", width: "120", sortable: true},
        {header: '학위코드', name: 'degreeCd', align: "center", width: "120", sortable: true},
        {header: '학과코드', name: 'classCd', align: "center", width: "120", sortable: true},
        {header: '전공', name: 'classMajor', align: "center", width: "120", sortable: true},
        {header: '부전공', name: 'classMinor', align: "center", width: "120", sortable: true},
        {header: '복수전공', name: 'classSmajor', align: "center", width: "120", sortable: true},
        {header: '학번', name: 'hakbun', align: "center", width: "120", sortable: true},
        {header: '직장명', name: 'companyNm', width: "120", sortable: true},
        {header: '부서', name: 'partNm', width: "120", sortable: true},
        {header: '직위', name: 'levelNm', width: "120", sortable: true},
        {header: '휴대폰', name: 'cellular', width: "120", sortable: true},
        {header: '메일', name: 'eMail', width: "120", sortable: true},
        {header: '우편번호', name: 'homeZipcd', width: "120", sortable: true},
        {header: '집주소1', name: 'homeAddress1', width: "200", sortable: true},
        {header: '사무실우편번호', name: 'officeZipcd', width: "120", sortable: true},
        {header: '사무실주소1', name: 'officeAddress1', width: "200", sortable: true}
      ];
      this.gridProps['options'].scrollX = true;
      this.gridProps['options'].scrollY = true;
      this.gridProps['data'] = listData || [];
    }
  }
};
</script>
